<template>
  <!-- 关于我们 -->
    <section class="bg-white py-16 md:py-24">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            关于创达
          </h2>
          <div class="w-20 h-1 bg-blue-700 mx-auto"></div>
        </div>
        <div class="flex flex-col md:flex-row items-center">
          <div class="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10">
            <img
              src="../assets/aboutus.jpg"
              alt="关于创达"
              class="rounded-lg shadow-xl w-full h-auto object-cover"
            />
          </div>
          <div class="w-full md:w-1/2">
            <h3 class="text-2xl font-bold text-gray-800 mb-4">关于我们</h3>
            <p class="text-gray-700 mb-6 leading-relaxed ">
              <span class="custom-txt-sj">&nbsp;&nbsp;&nbsp;四川创达芯仪科技有限公司</span>，于 2023
              年在成都创立。我们公司立足于前沿科技，致力于人工智能、边缘计算、声学技术、传感器技术和大数据分析等领域的创新研究与产品开发。我们为交通、民航、市政等行业提供先进的产品技术和系统解决方案，以增强客户的核心竞争力。
            </p>
            <p class="text-gray-700 mb-6 leading-relaxed">
               <span class="custom-txt-sj">&nbsp;&nbsp;&nbsp;创达芯仪科技有限公司</span>与电子科技大学、西南交通大学、北京理工大学等知名学府在
              AI
              算法、传感器技术等方面展开深度合作，共同推动产品创新。凭借卓越的产品实力，我们已成功入选为中国铁塔的行业战略合作伙伴。
            </p>
            <p class="text-gray-700 mb-6 leading-relaxed">
              <span class="custom-txt-sj">&nbsp;&nbsp;&nbsp;在创达芯仪</span>，我们不仅追求技术的卓越，更致力于通过创新技术推动行业进步，为社会创造更大的价值。
            </p>
            <h3 class="text-2xl font-bold text-gray-800 mb-4">核心价值观</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-lightbulb text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    创新驱动
                  </h4>
                  <p class="text-gray-600">
                    不断探索前沿技术，引领行业发展方向
                  </p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-users text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    客户至上
                  </h4>
                  <p class="text-gray-600">
                    以客户需求为中心，提供卓越的产品和服务
                  </p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-shield-alt text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    诚信负责
                  </h4>
                  <p class="text-gray-600">坚持诚信经营，对客户和社会负责</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="flex-shrink-0 mr-4">
                  <div
                    class="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center"
                  >
                    <i class="fas fa-handshake text-blue-700"></i>
                  </div>
                </div>
                <div>
                  <h4 class="text-lg font-semibold text-gray-800 mb-2">
                    合作共赢
                  </h4>
                  <p class="text-gray-600">与合作伙伴建立长期稳定的互利关系</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>


